import React from 'react';
import { Grid } from '@mui/material';
import {makeStyles} from "@mui/styles";

import "react-datepicker/dist/react-datepicker.css";

import { Title } from '../'
import TodayContents from "./TodayContents";

const useStyles = makeStyles(() => ({
  title: {
    marginLeft: 24,
    marginTop: 48,
  },
}));

export default function Header(props: any) {
  const classes = useStyles();
  const {dashboard} = props;

  return (
    <>
      <Grid container direction={"row"} justifyContent={'space-between'}>
        <Grid item>
          <Title className={classes.title}>오늘의 운송현황</Title>
        </Grid>
        <Grid item>
          <TodayContents today={dashboard.today}/>
        </Grid>
      </Grid>
    </>
  )
}